/** Full API base URL including /api/v1, used for all API calls.
 *  In dev, uses Vite proxy (same-origin) to avoid cross-origin cookie issues. */
export const API_BASE_URL: string = import.meta.env.DEV
    ? '/api/v1'
    : import.meta.env.VITE_API_URL || 'http://localhost:1324/api/v1'

/** Server host without /api/v1 suffix, used for static assets (e.g. product images) */
export const API_HOST: string = import.meta.env.DEV
    ? ''
    : API_BASE_URL.replace('/api/v1', '')

/** SSE endpoint URL — uses Vite proxy in dev, direct URL in prod */
export const SSE_URL: string = import.meta.env.DEV
    ? '/api/v1/notifications/stream'
    : `${API_BASE_URL.replace(/\/+$/, '')}/notifications/stream`
